import { action, computed } from 'easy-peasy';

const mpqModel = {
  name: null,
  email: null,
  answers: {},
  page: 1,

  setPage: action((state, payload) => {
    state.page = payload;
  }),

  setName: action((state, payload) => {
    state.name = payload;
  }),
  setEmail: action((state, payload) => {
    state.email = payload;
  }),
  setAnswers: action((state, payload) => {
    state.answers = { ...state.answers, ...payload };
  })
};

export default mpqModel;
